import React, { forwardRef, type Ref } from 'react';
import { IconButton as IconButtonOld } from '@atlaskit/button/new';
import { ThemedIconButton } from '@atlassian/jira-project-theme-components/src/ui/themed-button-new/ThemedButtonNew.tsx';
import { getIsSoftwareThemingM2Enabled } from '@atlassian/jira-project-theme-providers/src/utils/getIsSoftwareThemingEnabled.tsx';
import type { CommonNavMenuButtonProps } from './types.tsx';

export const CommonNavMenuButton = forwardRef(
	({ onClick, icon, ...props }: CommonNavMenuButtonProps, ref: Ref<HTMLButtonElement>) => {
		const IconButton = getIsSoftwareThemingM2Enabled() ? ThemedIconButton : IconButtonOld;
		return (
			<IconButton
				{...props}
				icon={icon}
				onClick={onClick}
				ref={ref}
				spacing="compact"
				appearance="subtle"
			/>
		);
	},
);
